import { render, staticRenderFns } from "./ReminderNotification.vue?vue&type=template&id=08b5328a&"
import script from "./ReminderNotification.vue?vue&type=script&lang=js&"
export * from "./ReminderNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports